// extracted by mini-css-extract-plugin
module.exports = {"auth":"Auth_auth__IyjzY"};